import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
export const SESSION_EXPIRED = "dayone:session-expired";
let sessionEpoch = 0;
export function beginAuthChange() {
  sessionEpoch += 1;
  refreshing?.controller.abort();
  refreshing = null;
}

// Bound reads, but never automatically replay a score, upload or other mutation.
api.interceptors.request.use((config) => {
  config._sessionEpoch ??= sessionEpoch;
  if (["get", "head"].includes(config.method) && !config.timeout) config.timeout = 12000;
  return config;
});

const NO_REFRESH = ["/auth/refresh", "/auth/login", "/auth/logout", "/auth/register"];
let refreshing = null;
function expireSession(config) {
  if (config._sessionEpoch === sessionEpoch && typeof window !== "undefined") {
    window.dispatchEvent(new Event(SESSION_EXPIRED));
  }
}
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    if (status === 403 && error.response?.data?.detail?.code === "premium_required") window.dispatchEvent(new Event("dayone:premium-required"));
    if (error.response?.data?.detail?.code === "account_verification_required") window.dispatchEvent(new CustomEvent("dayone:account-verification", { detail: error.response.data.detail }));
    const skip = NO_REFRESH.some((p) => (original.url || "").includes(p));
    const current = original._sessionEpoch === sessionEpoch;
    const transient = !error.response || [502, 503, 504].includes(status);
    if (current && transient && original.method === "get" && !original._readRetry && !axios.isCancel(error)) {
      original._readRetry = true;
      await new Promise((resolve) => setTimeout(resolve, 400));
      if (original._sessionEpoch !== sessionEpoch) return Promise.reject(error);
      return api(original);
    }
    if (current && status === 401 && !skip && !original._retry) {
      original._retry = true;
      try {
        if (!refreshing || refreshing.epoch !== sessionEpoch) {
          const entry = { epoch: sessionEpoch, controller: new AbortController() };
          entry.promise = api.post("/auth/refresh", {}, { timeout: 15000, signal: entry.controller.signal }).finally(() => {
            if (refreshing === entry) refreshing = null;
          });
          refreshing = entry;
        }
        await refreshing.promise;
        if (original._sessionEpoch !== sessionEpoch) return Promise.reject(error);
        return api(original);
      } catch (e) {
        // A network error is not proof that the account/session is invalid.
        if (e.response?.status === 401) expireSession(original);
        return Promise.reject(e);
      }
    }
    if (current && status === 401 && !skip && original._retry) expireSession(original);
    return Promise.reject(error);
  }
);

export function formatRequestError(error) {
  if (error.response?.data?.detail != null) return formatApiError(error.response.data.detail);
  if (!error.response || error.response.status >= 500) {
    return "Le serveur est momentanément injoignable. Réessaie dans quelques instants ; tes identifiants ne sont pas remis en cause.";
  }
  return "La demande n’a pas abouti. Réessaie dans quelques instants.";
}
export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
export const fmtMoney = (n) => {
  const v = Number(n || 0);
  if (Math.abs(v) >= 1e6) return `${(v / 1e6).toFixed(v % 1e6 === 0 ? 0 : 1)}M €`;
  if (Math.abs(v) >= 1e3) return `${(v / 1e3).toFixed(0)}k €`;
  return `${v} €`;
};

